import React from "react";

import { canvasDocumentRoute, canvasPreviewableRoute } from "helpers";
import DocumentCanvas from "views/canvas/DocumentCanvas";
import PreviewableCanvas from "views/canvas/PreviewableCanvas";
import RoutesSwitch from "providers/RoutesSwitch";

export default function CanvasView() {
  return (
    <>
      <RoutesSwitch
        rules={[
          {
            route: canvasDocumentRoute,
            exact: true,
            Component: DocumentCanvas,
          },
          {
            route: canvasPreviewableRoute,
            exact: true,
            Component: PreviewableCanvas,
          },
        ]}
      />
    </>
  );
}
